import { FC } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ExperienceApi } from 'src/api';
import { ExperienceResponse } from 'src/api/experience/types';
import { Loader } from 'src/components';
import { RestrictToAuth } from 'src/utilityComponents';
import { NewExperienceBanner } from './NewExperienceBanner';
import { CommunityCoursesBanner } from './CommunityCoursesBanner';
import * as S from './styles';

export const MigrationBanner: FC = () => {
  const { data: experienceData, isLoading } = useQuery<ExperienceResponse>({
    queryKey: ['experience'],
    queryFn: () => {
      return ExperienceApi.getExperience();
    },
  });

  const { hasCommunity, hasOfficialClassicCourses, hasOfficial } = experienceData ?? {};
  const isPureUGC = hasCommunity && !hasOfficialClassicCourses && !hasOfficial;

  return (
    <RestrictToAuth>
      {isLoading ? (
        <S.LoaderContainer>
          <Loader />
        </S.LoaderContainer>
      ) : isPureUGC ? (
        <CommunityCoursesBanner />
      ) : (
        <NewExperienceBanner isHybrid={hasCommunity} />
      )}
    </RestrictToAuth>
  );
};
